import HelloSign from 'hellosign-embedded';

import config from '../config';
import API from '../config/api';

class HelloSignUtil {
	constructor() {
		this.client = new HelloSign({ clientId: '98d741aae14079ffeb9aec1c2e89c0ec' });
	}

	RequestSignature = async (readyEvent = ()=>{}) => {
		try {
			const { applicationId, name, email, token } = this;
			const signature = await API.RequestSignature(token, { applicationId, name, email });

			if (signature.status != 201) throw { ...signature };

			this.EmbedDocument(signature.data, readyEvent);

			return { status: signature.status };
		} catch (err) {
			return err;
		}
	};

	EmbedDocument = (signature, readyEvent) => {
		const { embeddedUrl, signatureId, signatureRequestId } = signature,
			{ applicationId, token } = this;

		this.client.open(embeddedUrl, {
			allowCancel: true,
			skipDomainVerification: config.hellosign.skipDomainVerification,
		});
	
		this.client.on('ready', (data) => {
			if(readyEvent) readyEvent();
		});
		this.client.on('sign', (data) => {
			API.UpdateSignature(token, { applicationId, signatureId, signatureRequestId });
		});
		this.client.on('finish', () => { window.location.replace('/') });
	};

	DownloadSignedDocument = () => {
		const { token, signatureRequestId } = this;

		const viewFile = window.open();

		API.GetSignatureRequestDownload(token, { signatureRequestId }).then((response) => {
			viewFile.location.href = response.data;
			setTimeout(() => viewFile.close(), 3000);
		});
	};
}

// export default new HelloSignUtil()
export default HelloSignUtil;
